
import hmacSHA256 from "crypto-js/hmac-sha256";
export const key = () => {



    const privateKey = "2baf9b8651666bf30f76f10aa1ed10b3481ee5fe8ecebb84ddd221cc59a0500a";
    const myToken = process.env.REACT_APP_SA_TOKEN;
    const text = myToken + "::" + new Date().getUTCHours();
    const key = hmacSHA256(text, privateKey);


    return key;

};

